<template>
    <div>
        <aside class="side-widget">
            <div class="inner">
                <div class="logo"><a href="#"><img :src="'/static/img/shamal-logo-w.png'" alt=""></a></div>


                <div class="show-mobile">
                    <div class="site-menu">
                        <ul>

                        <li><a :href="'/'">About us</a></li>
                        <li><a :href="'/what-we-do/'">What we do</a></li>
                        <li><a :href="'/clients/'">Clients</a>
                        <ul>
                          <li><a href="/clients/">Our Clients</a></li>
                            <li>  <a href="/case-studies/">Case Studies</a></li>

                        </ul>
                        </li>
                        <li><a href="/media-room/">Media Room</a>
                           <ul>
                                <li><a href="/media-room/">News (English)</a></li>
                                <li><a href="/media-room-arabic/">News (Arabic)</a></li>
                                <li><a href="/reports/">Industry Reports & Guest Columnist</a></li>
                            </ul>
                        </li>
                        <li><a :href="'/careers/'">Careers</a></li>
                        <li><a :href="'/contact/'">Contact</a></li>
                        </ul>
                    </div>
                    <!-- end site-menu -->
                </div>
                <!-- end show-mobile -->
                <small>&copy; 2020 Shamal Communications, All rights reserved. </small></div>
            <!-- end inner -->
        </aside>
        <div class="topbar">
            <div class="container">

                <div class="social-media">
                    <ul>
                        <li><a href="https://www.linkedin.com/company/shamal-marketing-communications/" target="_blank"><i class="lni lni-linkedin-original" ></i></a></li>
                        <li><a href="https://www.facebook.com/shamalcomms" target="_blank"><i class="lni lni-facebook-filled" ></i></a></li>
                        <li><a href="https://twitter.com/shamalcomms" target="_blank"><i class="lni lni-twitter-original"></i></a></li>
                        <li><a href="https://www.instagram.com/shamalcomms/" target="_blank"><i class="lni lni-instagram"></i></a></li>
                    </ul>
                </div>
                <div class="tr">
                <div class="email"><i class="lni lni-envelope"></i> <span><a href="mailto:shamal@shamalcomms.com">shamal@shamalcomms.com</a></span>	 </div>
                <div class="phone"><i class="lni lni-mobile"></i> <span><a href="tel:+97143652711">+971 (0)4 365 2711</a></span></div>
                    </div>
            </div>
            <!-- end container -->
        </div>

        <nav class="navbar">
            <div class="container">
                <div class="logo"><a href="/"> <img :src="'/static/img/shamal-logo.png'"
                                                    alt="Image"> </a></div>
                <!-- end logo -->
                <div class="site-menu">
                    <ul>
                        <li><a :href="'/'">About us</a>
                        <ul>
                          <li><a href="/our-international-network/">Our International Network</a></li>
                        </ul>
                        </li>
                        <li><a :href="'/what-we-do/'">What we do</a></li>
                        <li><a :href="'/clients/'">Clients</a>
                          <ul>
                          <li><a href="/clients/">Our Clients</a></li>
                            <li>  <a href="/case-studies/">Case Studies</a></li>

                        </ul>
                        </li>
                        <li><a href="/media-room/">Media Room</a>
                            <ul>
                                <li><a href="/media-room/">News (English)</a></li>
                                <li><a href="/media-room-arabic/">News (Arabic)</a></li>
                                <li><a href="/reports/">Industry Reports & Guest Columnist</a></li>
                              <li><a href="/photography/">Photography</a></li>
                              <li><a href="/videography/">Videography</a></li>
                            </ul>
                        </li>
                        <li><a :href="'/careers/'">Careers</a></li>
                        <li><a :href="'/contact/'">Contact</a></li>
                    </ul>
                </div>
                <!-- end site-menu -->
                <div class="search-button"><i class="lni lni-search-alt"></i></div>
                <!-- end search-button -->
                <div class="hamburger-menu"><span></span> <span></span> <span></span></div>
                <!-- end hamburger-menu -->
            </div>
            <!-- end container -->
        </nav>
    </div>

</template>

<script>
    export default {
        props: ['items', 'logo'],

        mounted() {

            const hamburger = document.querySelector('.hamburger-menu');
            hamburger.addEventListener('click', function () {
                this.classList.toggle('open');

                document.querySelector('.side-widget').classList.toggle('active');
                document.body.classList.toggle('overflow');
            })



        }


    }


</script>

<style scoped>

    .tr {
        display: flex;

    }
    .tr > div {
        margin-right: 10px
    }

    @media (max-width: 550px){
        .tr span {
            display: none;
        }
    }


    /* HAMBURGER MENU */
    .hamburger-menu {
        width: 30px;
        height: 20px;
        position: relative;
        transform: rotate(0deg);
        transition-duration: 500ms;
        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
        cursor: pointer;
    }

    .hamburger-menu span {
        display: block;
        position: absolute;
        height: 2px;
        width: 100%;
        background: #9a181e;
        opacity: 1;
        right: 0;
        transform: rotate(0deg);
        transition: .25s ease-in-out;
    }

    .hamburger-menu span:nth-child(1) {
        top: 0px;
        width: 13px;
    }

    .hamburger-menu span:nth-child(2) {
        top: 9px;
    }

    .hamburger-menu span:nth-child(3) {
        top: 18px;
        width: 100%;
    }

    .hamburger-menu:hover span {
        width: 30px !important;
    }

    .hamburger-menu.open span {
        width: 20px !important;
    }

    .hamburger-menu.open span:nth-child(1) {
        top: 9px;
        right: 0;
        transform: rotate(135deg);
        width: 28px !important;
    }

    .hamburger-menu.open span:nth-child(2) {
        opacity: 0;
        right: 20px;
    }

    .hamburger-menu.open span:nth-child(3) {
        top: 9px;
        right: 0;

        transform: rotate(-135deg);
        width: 28px !important;
    }

    /* SWIPER PAGINATION */
    .swiper-pagination {
        width: 100%;
    }

    .swiper-pagination .swiper-pagination-bullet {
        width: 20px;
        height: 6px;
        border-radius: 6px;
        background: #fff;
        transition: all .35s ease-in-out;
        opacity: 0.3;
    }

    .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 50px;
        background: #9a181e;
        opacity: 1;
    }

    /* SIDE WIDGET */
    .side-widget {
        width: 400px;
        height: 100vh;
        max-width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: fixed;
        left: -100%;
        top: 0;
        transition: all 0.4s ease;
        transition-duration: 500ms;
        -webkit-transition-duration: 500ms;
        transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
        -webkit-transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
        background: #9a181e;
        /*background-image: url("../images/pattern-bg.png");*/
        background-position: center;
        background-size: cover;
        z-index: 6;
        box-shadow: 0 0 60px rgba(0, 0, 0, 0.4);
        padding: 20px 30px;
        color: #fff;
    }

    .side-widget .inner {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        overflow-y: auto;
        height: 100%;
    }

    .side-widget .logo {
        width: 100%;
        display: block;
        margin-bottom: 40px;
    }

    .side-widget .logo img {
        height: 49px;
    }

    .side-widget .show-mobile {
        display: none;
    }

    .side-widget .hide-mobile {
        width: 100%;
        display: inline-block;
    }



    .side-widget .gallery a {
        width: 50%;
        padding-right: 3px;
    }

    .side-widget .gallery a:last-child {
        padding-left: 3px;
    }

    .side-widget p {
        width: 100%;
        display: block;
        color: #fff;
    }

    .side-widget .widget-title {
        display: inline-block;
        margin-bottom: 15px;
        border-bottom: 4px solid #fbc50b;
        font-size: 20px;

        padding-bottom: 5px;
    }

    .side-widget .address {
        width: 100%;
        display: block;
    }

    .side-widget .address a {
        display: inline-block;
        color: #fff;
    }

    .side-widget .social-media {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
    }

    .side-widget .social-media li {
        display: inline-block;
        margin-right: 20px;
        padding: 0;
        list-style: none;
    }

    .side-widget .social-media li a {
        color: #fff;
        font-size: 13px;
        font-weight: 600;
    }

    .side-widget .social-media li a:hover {
        color: #fbc50b;
    }

    .side-widget .site-menu {
        width: 100%;
        display: block;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .side-widget .site-menu ul {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
    }

    .side-widget .site-menu ul li {
        display: block;
        margin: 3px 0;
        padding: 0;
        list-style: none;
    }

    .side-widget .site-menu ul li ul {
        display: none;
        padding-left: 20px;
        margin-bottom: 10px;
    }

    .side-widget .site-menu ul li a {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
      font-family: Arial Narrow, Arial, sans-serif;
    }

    .side-widget .site-menu ul li a:hover {
        text-decoration: none;
        color: #fbc50b;
    }

    .side-widget small {
        font-size: 11px;
        width: 100%;
        display: block;
        margin-top: 20px;
        color: #fff;
    }

    .side-widget.active {
        left: 0;
    }

    /* TOPBAR */
    .topbar {
        width: 100%;
        height: 50px;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
    .home .topbar .container {
        color: #fff;
    }

    .topbar .container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        color: #9a181e;
        font-size: 15px;
    }

    .topbar .text {
        display: inline-block;
        position: relative;
    }

    .topbar .text:before {
        content: "";
        width: 100%;
        height: 3px;
        background: #9a181e;
        position: absolute;
        left: 0;
        bottom: 3px;
        z-index: -1;
    }

    .topbar .social-media {
        display: inline-block;
    }

    .topbar .social-media ul {
        display: inline-block;
        margin: 0;
        margin-left: 10px;
        padding: 0;
    }

    .topbar .social-media ul li {
        display: inline-block;
        margin: 0 4px;
        padding: 0;
        list-style: none;
    }
    .home .topbar .social-media ul li a {

        color: #fff;
    }

    .topbar .social-media ul li a {
        color: #9a181e;
        font-size: 20px;
    }

    .topbar .social-media ul li a:hover {
        color: #c12e35;

    }

    .topbar .phone {
        display: inline-block;
    }

    .topbar .phone i {
        font-size: 20px;
        display: inline-block;
        transform: translateY(2px);
    }

    /* NAVBAR */
    .navbar {
        width: 1300px;
        max-width: 100%;
        display: flex;
        flex-wrap: wrap;
        background: #fff;
        /*background: url("../images/pattern-bg.png") center #009a4e;*/
        color: #fff;
        background-size: cover;
        position: absolute;
        left: 50%;
        top: 50px;
        padding: 30px 0;
        transform: translateX(-50%);
        border-radius: 4px;
        z-index: 3;
    }

    .navbar:before {
        content: "";
        width: calc(100% - 40px);
        height: 8px;
        background: #000;
        position: absolute;
        left: 20px;
        bottom: -8px;
        opacity: 0.2;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
    }

    .navbar .logo {
        margin-left: 0;
    }

    .navbar .logo a {
        display: inline-block;
    }

    .navbar .logo a img {
        height: 48px;
    }

    .navbar .site-menu {
        margin: 0 30px;
    }

    .navbar .site-menu ul {
        display: block;
        margin: 0;
        padding: 0;
    }

    .navbar .site-menu ul li {
        display: inline-block;
        margin: 0 20px;
        padding: 0;
        list-style: none;
        font-weight: 600;
        position: relative;
      font-family: Arial Narrow, Arial, sans-serif;
    }

    .navbar .site-menu ul li ul {
        position: absolute;
        left: -20px;
        top: calc(100% + 20px);
        background: #9a181e;
        padding: 15px 0;
        margin: 0;
        border-radius: 4px;
        display: none;
    }

    .navbar .site-menu ul li ul:before {
        content: "";
        width: 100%;
        height: 20px;
        position: absolute;
        left: 0;
        top: -20px;
    }

    .navbar .site-menu ul li ul:after {
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 6px 6px 6px;
        border-color: transparent transparent #9a181e transparent;
        position: absolute;
        left: 20px;
        top: -6px;
    }

    .navbar .site-menu ul li ul li {
        width: 100%;
        display: block;
        white-space: nowrap;
        margin: 0;
        padding: 5px 20px;
        list-style: none;
    }

    .navbar .site-menu ul li ul li a {
        display: inline-block;
        color: #fff;
    }

    .navbar .site-menu ul li ul li a:hover {
        color: #fff;
        text-decoration: underline;
    }

    .navbar .site-menu ul li:hover ul {
        display: block;
    }

    .navbar .site-menu ul li a {
        display: inline-block;
        color: #121212;
        position: relative;
    }

    .navbar .site-menu ul li a:after {
        content: "";
        width: 0;
        height: 3px;
        background: #9a181e;
        position: absolute;
        left: 50%;
        bottom: -5px;
        -webkit-transition: all .35s ease-in-out;
        -moz-transition: all .35s ease-in-out;
        -ms-transition: all .35s ease-in-out;
        -o-transition: all .35s ease-in-out;
        transition: all .35s ease-in-out;
    }

    .navbar .site-menu ul li a:hover {
        text-decoration: none;
        color: #9a181e;
    }

    .navbar .site-menu ul li a:hover:after {
        width: 100%;
        left: 0;
    }

    .navbar .search-button {
        display: inline-block;
        font-size: 22px;
        cursor: pointer;
    }

    .navbar .hamburger-menu {
        display: none;
    }


    /* RESPONSIVE MEDIUM  */
@media only screen and (max-width: 1199px), only screen and (max-device-width: 1199px) {

  .navbar .site-menu {
    margin: 0 auto;
  }

  .navbar .hamburger-menu {
    margin-left: 20px;
      display: inline-block;
  }


  .sidebar {
    padding-left: 0;
  }
}
/* RESPONSIVE TABLET  */
@media only screen and (max-width: 1195px), only screen and (max-device-width: 1195px) {
  .section-title h2 br {
    display: none;
  }

  .navbar .site-menu {
    display: none;
  }

  .navbar .hamburger-menu {
    margin-left: 30px;
  }

  .side-widget .hide-mobile {
    display: none;
  }

  .side-widget .show-mobile {
    display: block;
  }

  .side-slider {
    margin-top: 40px;
  }

  .side-slider .note-box {
    left: -20px;
  }

  .sidebar {
    margin-top: 50px;
  }



  .side-image-box figure {
    width: 100%;
  }

  .side-image-box .content {
    width: 100%;
  }

  .side-content-image-box .content {
    width: 100%;
  }

  .side-content-image-box figure {
    width: 100%;
  }

å

  .row.align-items-center .col-lg-4:nth-child(5) {
    order: 2;
  }

  .row.align-items-center .col-lg-8:nth-child(6) {
    order: 1;
  }

  .cd-horizontal-timeline .timeline .events-wrapper {
    overflow: auto;
  }


  .footer form {
    margin-bottom: 0;
  }
}
/* RESPONSIVE MOBILE */
@media only screen and (max-width: 767px), only screen and (max-device-width: 767px) {
  .topbar .text {
    display: none;
  }

  .search-box .inner {
    width: 80%;
  }

  .header .main-slider .swiper-slide .slide-inner h1 {
    font-size: 60px;
  }




}

    @media (max-width: 1199px) {
      .side-widget .site-menu ul li ul {
        display: block;
      }
    }
</style>